<router-outlet></router-outlet>
<form class="was-validation" [formGroup]="form">
  <div class="row">
    <b>Dados do(a) Colaborador(a)</b>
    <div class="col-12 col-lg-3 col-xl-2 col-xxl-2">
      <div class="form-floating">
        <input
          type="text"
          id="txtMatricula"
          formControlName="matricula"
          (input)="Get($event)"
          class="form-control mb-3"
          placeholder="Matrícula *"
          mask="0{6}"
          inputmode="numeric"
          pattern="[0-9]*"
          (focus)="moveCursorToEnd($event)"
          autofocus
        />
        <label for="txtMatricula">Matrícula *</label>
      </div>
    </div>
    <div class="col-12 col-lg-9 col-xl-8 col-xxl-8">
      <div class="form-floating">
        <input
          type="text"
          id="txtNome"
          formControlName="nome"
          class="form-control upper mb-3"
          placeholder="Nome *"
          readonly
        />
        <label for="txtNome">Nome *</label>
      </div>
    </div>
    <div class="col-12 col-lg-3 col-xl-2 col-xxl-2">
      <div class="form-floating">
        <input
          *ngIf="showTelefone"
          type="text"
          id="txtTelefone"
          formControlName="telefone"
          class="form-control mb-3"
          placeholder="Telefone *"
          mask="(00) 0000-0000||(00) 00000-0000"
          inputmode="numeric"
          pattern="[0-9]*"
          [dropSpecialCharacters]="true"
        />
        <label for="txtTelefone">Telefone *</label>
      </div>
    </div>
  </div>
  <div class="row">
    <b>Dados do(a) Candidato(a)</b>
    <div class="col-12 col-lg-3 col-xl-2 col-xxl-2">
      <div class="form-floating">
        <input
          *ngIf="showTelefone"
          type="text"
          id="txtTelefoneDoCandidato"
          formControlName="telefoneDoCandidato"
          class="form-control mb-3"
          placeholder="Telefone *"
          mask="(00) 0000-0000||(00) 00000-0000"
          inputmode="numeric"
          pattern="[0-9]*"
          [dropSpecialCharacters]="true"
        />
        <label for="txtTelefoneDoCandidato">Telefone *</label>
      </div>
    </div>
    <div class="col-12 col-lg-10 col-xl-10 col-xxl-10">
      <div class="form-floating">
        <input
          type="text"
          id="txtNomeDoCandidato"
          formControlName="nomeDoCandidato"
          class="form-control upper mb-3"
          placeholder="Nome *"
        />
        <label for="txtNomeDoCandidato">Nome *</label>
      </div>
    </div>
  </div>
  <div class="row">
    <b>Anexar currículo *</b>
    <app-upload (fileSelected)="onFileReceived($event)"></app-upload>
  </div>
  <div class="col-auto">
    <button
      [disabled]="form.invalid"
      type="button"
      (click)="Post()"
      class="btn btn-md btn-success mt-5"
    >
      <i class="fa fa-check"></i> Indicar
    </button>
  </div>
  <app-loading></app-loading>
</form>
